import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../Contexts/AuthContext';
import { useAutoLogout } from '../../Hooks/useAutoLogout';
import AdminNavbar from './AdminNavbar';
import AdminFooter from './AdminFooter';
import styles from './AdminLayout.module.scss';

interface AdminLayoutProps {
  children: React.ReactNode;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  
  // Usar o hook de auto logout (2 horas por padrão)
  useAutoLogout();

  React.useEffect(() => {
    if (!user) {
      navigate('/admin/login');
      return;
    }
  }, [user, navigate]);

  // Se não há usuário, não renderizar o layout
  if (!user) {
    return null;
  }

  return (
    <div className={styles.adminLayout}>
      <AdminNavbar />
      <main className={styles.mainContent}>
        {children}
      </main>
      <AdminFooter />
    </div>
  );
};

export default AdminLayout;
